import React, { Component } from "react";
import firebase from "../firebase";
import Header from "./includes/Admin_Header";
import { Redirect, Route } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./pages/Dashboard";
import Pages from "./pages/Pages";
import Images from "./pages/Images";
import Banner from "./pages/Banner";

import "./App.css";

class Admin extends Component {
  state = {
    loggedIn:
      sessionStorage.loggedIn !== undefined
        ? Boolean(sessionStorage.loggedIn)
        : false,
    signedOut: false,
    email: "",
    username: "",
    uid: ""
  };

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user)
        this.setState({ loggedIn: true, signedOut: false }, () => {
          let email = user.email;
          let uid = user.uid;
          this.isLoggedIn(email, uid);
        });
      else this.setState({ loggedIn: false });
    });
    if (document.getElementsByClassName("admin")) {
      document.querySelector(".front-end-header").style.display = "none";
      document.querySelector(".front-end-footer").style.display = "none";
      document.querySelector(".frontend").style.display = "none";
    }
  }

  isLoggedIn = (email, uid = null) => {
    this.setState({ loggedIn: true, email: email, uid: uid }, () => {
      let db = firebase.database();
      db.ref(`users/${this.state.uid}`).on("value", snapshot => {
        this.setState({ username: snapshot.val() });
      });
      sessionStorage.loggedIn = this.state.loggedIn;
    });
  };

  signOut = e => {
    e.preventDefault();
    firebase
      .auth()
      .signOut()
      .then(() => {
        sessionStorage.clear();
        this.setState({ loggedIn: false });
      })
      .catch(err => console.error(err));
  };

  componentWillUnmount() {
    document.querySelector(".front-end-header").style.display = "block";
    document.querySelector(".front-end-footer").style.display = "block";
  }

  render() {
    return (
      <div className="admin">
        <Header
          name={this.state.username}
          loggedIn={this.state.loggedIn}
          logout={this.signOut}
        />
        <div className="admin-dashboard">
          <Route
            exact
            path="/admin"
            render={() =>
              this.state.loggedIn ? (
                <Dashboard username={this.state.username} />
              ) : (
                <Redirect from="/admin" to="/admin/login" />
              )
            }
          />

          <Route
            path="/admin/pages"
            render={() =>
              this.state.loggedIn ? (
                <Pages username={this.state.username} />
              ) : (
                <Redirect to="/admin/login" />
              )
            }
          />

          <Route
            path="/admin/images"
            render={() =>
              this.state.loggedIn ? <Images /> : <Redirect to="/admin/login" />
            }
          />

          <Route
            path="/admin/banner"
            render={() =>
              this.state.loggedIn ? <Banner /> : <Redirect to="/admin/login" />
            }
          />

          <Route
            path="/admin/*"
            render={() =>
              this.state.loggedIn ? null : <Redirect to="/admin/login" />
            }
          />

          <Route
            exact
            path="/admin/login"
            render={() => (
              <Login
                loggedIn={this.state.loggedIn}
                isLoggedIn={this.isLoggedIn}
              />
            )}
          />

          {/* <iframe id="invis" name="invis" title="fuckyou" /> */}
        </div>
      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/admin/Admin.js